import { api } from "./api";
import { useAuthStore } from "./auth-store";

/**
 * Hydrate the client session from the server's cookie session. Call once on app
 * load: if the HttpOnly cookie is valid the server returns the user + CSRF token;
 * otherwise it 401s and we clear the local cache. Returns true when authed.
 */
export async function bootstrapSession(): Promise<boolean> {
  const r = await api.auth.session();
  // A session still on a temporary password is not usable yet: send the user
  // through /login, which signs in again and asks for the new password.
  if (r.ok && !r.data.must_change_password) {
    useAuthStore.getState().setSession(r.data.user, r.data.csrf_token);
    return true;
  }
  useAuthStore.getState().clear();
  return false;
}

/**
 * Log out: destroy the server session + cookies (the server also ends the
 * Keycloak or Dyuthi Accounts session), drop the local cache, then go to the
 * URL the server returns (our own /login).
 */
export async function doLogout(): Promise<void> {
  // The server ends the Keycloak SSO session itself (back-channel) and returns
  // where to go next (our own /login) — one step, no Keycloak confirm page. The
  // fallback is our own login page too, never the interactive IdP logout URL.
  let endSessionUrl = "https://bill.dyuthitech.in/login";
  try {
    const r = await api.auth.logout();
    if (r.ok && r.data.end_session_url) endSessionUrl = r.data.end_session_url;
  } catch {
    /* best-effort; clear + redirect regardless */
  }
  useAuthStore.getState().clear();
  window.location.href = endSessionUrl;
}
